const config = {
  env: process.env.REACT_APP_ENV,
  appName: process.env.REACT_APP_NAME,
  backendEndpoint: process.env.REACT_APP_BACKEND_ENDPOINT,
  emailEndpoint: process.env.REACT_APP_EMAIL_ENDPOINT,
  adminPOFilepath: process.env.REACT_APP_ADMIN_PO_FILEPATH,
  adminInvoiceDocpath: process.env.REACT_APP_INVOICE_DOC_PATH,
  adminProfileDocpath: process.env.REACT_APP_PROFILE_DOC_PATH,
  coreAuthToken: process.env.REACT_APP_CORE_AUTH_TOKEN,
  appHost: process.env.REACT_APP_HOST,
  emailAuthToken: process.env.REACT_APP_EMAIL_AUTH_TOKEN,
  souceMap: process.env.GENERATE_SOURCEMAP,
  reduxDevToolOption: process.env.REACT_APP_DEV_TOOL_OPTION,
};

export default config;
